export enum PrimaryButtonType {
    Share,
    Phone,
    Contacts,
}

export interface IPrimaryButtonConfig {
    icon: string;
}